<template>
  <div id="app">
    <!-- 頂部導航欄 -->
    <div class="top-bar">
      <!-- 左：公司名稱 -->
      <!-- <div class="left-logo" >CHRGIE POWER</div> -->
      <div class="footer-left">
        <img
          @click="showIntro = true"
          src="@/assets/menuRight.png"
          alt="logo"
          class="footer-logo"
        />
      </div>
      <!-- 中：導航選單 -->
      <el-menu
        class="center-menu"
        mode="horizontal"
        text-color="#fff"
        active-text-color="#fff"
        :default-active="activePath"
        background-color="rgb(236, 105, 61)"
        @select="handleSelect"
      >
        <!-- <el-submenu index="1">
          <el-menu-item index="/home/aboutUs">{{
            $t("menu.aboutUs")
          }}</el-menu-item>
          <template slot="title">{{ $t("menu.aboutUs") }}</template>
          <el-menu-item index="/home/intro">{{
            $t("menu.serviceIntro")
          }}</el-menu-item>
          <el-menu-item index="/home/usage">{{
            $t("menu.usage")
          }}</el-menu-item>
          <el-menu-item index="/home/fees">{{ $t("menu.fee") }}</el-menu-item>
          <el-menu-item index="/home/brands">{{
            $t("menu.brands")
          }}</el-menu-item>
        </el-submenu> -->
        <el-menu-item index="/home/intro">{{
          $t("menu.serviceIntro")
        }}</el-menu-item>
        <el-menu-item index="/bussinesscooperator">{{
          $t("menu.bussinesscooperator")
        }}</el-menu-item>
        <el-menu-item index="/faq">{{ $t("menu.faq") }}</el-menu-item>
        <el-menu-item index="/advertisingplatform">{{
          $t("menu.advertisingplatform")
        }}</el-menu-item>
        <el-menu-item index="/contactUS">{{
          $t("menu.contactUS")
        }}</el-menu-item>
      </el-menu>

      <!-- 右：語言切換 -->
      <div class="right-lang">
        <el-select
          v-model="locale"
          @change="changeLang"
          size="mini"
          style="width: 120px"
        >
          <el-option label="繁體中文" value="zh-TW"></el-option>
          <el-option label="简体中文" value="zh-CN"></el-option>
          <el-option label="English" value="en"></el-option>
        </el-select>
      </div>
    </div>

    <!-- 點擊左側 LOGO 時顯示單張圖片 -->
    <div v-if="showIntro" class="intro-image">
      <img :src="introImage" class="full-image" />
    </div>

    <!-- 頁面主體 -->
    <div v-if="!showIntro" style="padding: 20px">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale: this.$i18n.locale,
      activePath: this.$route.path,
       showIntro: this.$route.path === '/' || this.$route.path === '/home',
      introImage: require('@/assets/loRLogo.jpg') // 單張圖片
    }
  },
  watch: {
    '$route.path'(val) {
      this.activePath = val
       this.showIntro = (val === '/' || val === '/home')
    }
    
  },
  methods: {
     handleSelect(key) {
    this.showIntro = false;
    if (key === '/bussinesscooperator') {
      // 这里写你要跳转的外部链接
      window.open('https://partner.chrgiepower.com/'); // 新窗口打开
      return; // 跳转后return，避免再执行router.push
    }
    if (this.$route.path !== key) {
      this.$router.push(key);
    }
  },
    changeLang(lang) {
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped>
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px; /* 高度變大 */
  line-height: 80px;
  background: rgb(236, 105, 61); /* 橙色背景 */
  width: 100%;
}

.left-logo {
  padding: 0 20px;
  font-size: 28px;
  font-weight: bold;
  color: #fff; /* 白色字 */
  cursor: pointer;
}
.right-lang {
  padding: 0 20px;
}
/* 大屏（1920px+） */
@media (min-width: 1920px) {
  .intro-image {
    width: 100%;
    height: 745px;
  }

  .full-image {
    width: 100%;
    height: 745px;
    object-fit: cover;
  }
}

/* 平板（768px ~ 1023px） */
@media (max-width: 1500px) and (min-width: 768px) {
  .intro-image {
    width: 100%;
    height: 576px;
  }

  .full-image {
    width: 100%;
    height: 576px;
    object-fit: cover;
  }
}

/* 手机（小于 768px） */
@media (max-width: 767px) {
  .intro-image {
    width: 100%;
    height: 367px;
  }

  .full-image {
    width: 100%;
    height: 367px;
    object-fit: cover;
  }
}
/* 菜单字体大小 */
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 20px !important; /* 字体变大 */
}
.center-menu {
  flex: 1;
  display: flex;
  justify-content: center;
  background-color: rgb(236, 105, 61) !important;
  border-bottom: none !important; /* 去掉横线 */
}
.footer-left {
  width: 389px;
  height: 80px;
  line-height: 80px;
  display: flex;
}
.el-menu--horizontal > .el-menu-item:hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent !important;
}
</style>
